export const AcceptIcon = (
  props: React.SVGAttributes<SVGSVGElement> & { color?: string }
) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='16'
    height='16'
    viewBox='0 0 16 16'
    fill='none'
  >
    <mask
      id='mask0_100_8218'
      mask-type='alpha'
      maskUnits='userSpaceOnUse'
      x='2'
      y='3'
      width='13'
      height='10'
    >
      <path
        d='M13.5 4.5L6.5 11.5L3 8'
        stroke='black'
        strokeWidth='1.25'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </mask>
    <g mask='url(#mask0_100_8218)'>
      <path d='M16 0H0V16H16V0Z' fill={props.color || '#3BAAB0'} />
    </g>
  </svg>
)
